import EventEmitter from "eventemitter3";
import axios from "axios";
import PIXILoader from "./PIXILoader.js";
import Library      from "../utils/Library";
export default class Loader extends EventEmitter
{
    static setAsLoaded (strKey)
    {
        if (!Array.isArray (Loader.loadURLS))
        {
            Loader.loadURLS = [];
        }

        let isLoaded = Loader.loadURLS.includes(strKey);

        if (!isLoaded)
        {
            Loader.loadURLS.push(strKey);
        }

        return isLoaded;

    }
    constructor(strPathAssetsList)
    {
        super();


        this.fctLoadNextGroup = () => this.loadNextGroup();
        this.fctOnPixiLoaderGroupLoaded = (resources) => this.onPixiLoadedComplete( resources);
        this.pixiLoader = new PIXILoader();
        this.pixiLoader.on("group-loaded", this.fctOnPixiLoaderGroupLoaded );



        this.fctLoader = {
            "images": (group) => this.loadPixiAssets(group),
             "atlas": (group) => this.loadPixiAssets(group),
             "shaders": (group) => this.loadShaders(group),
            // "fonts": (group) => this.loadFonts(group),
            // "audios": (group) => this.loadAudios(group),
             "datas": (group) => this.loadDatas(group),
        }

        this.loadAssetsList(strPathAssetsList);


    }

    async loadAssetsList (_strAssetsList)
    {
        //_strAssetsList = Loader.addVersionToURL (_strAssetsList);
        let response  = await axios.get(_strAssetsList);


        this.arrAssetsGroups = response.data;

        this.loadNextGroup();


    }

    async loadNextGroup ()
    {
        if (this.arrAssetsGroups.length === 0)
        {
            this.emit("load-complete");
            return;
        }


        let group = this.arrAssetsGroups.shift();

        let strType = group.type;

        if (this.fctLoader[strType] !== undefined)
        {
            await this.fctLoader[strType](group);
        }
        else
        {
            await this.loadNextGroup();
        }
    }


    async loadPixiAssets (group)
    {
        this.pixiLoader.loadGroup(group.assets);
        //when this is loaded, onPixiLoadedComplete will be called
    }

    onPixiLoadedComplete (resources)
    {
        this.loadNextGroup();
    }

    async loadDatas(group)
    {
        for (let i = 0; i < group.assets.length; i++)
        {
            let url = group.assets[i].url;
            let response  = await axios.get(url);

            Library.instance.addData(group.assets[i].key, response.data);


        }

        await this.loadNextGroup();
    }

    async loadShaders(group)
    {
        for (let i = 0; i < group.assets.length; i++)
        {
            let url = group.assets[i].url;
            let response  = await axios.get(url);

            Library.instance.addShader(group.assets[i].key, response.data);


        }

        await this.loadNextGroup();
    }

    static addVersionToURL (url)
    {
        let strQueryParam = url.indexOf("?") > -1 ? "&" : "?";

        url += strQueryParam + "v=" + __MIX_COMPILATION_DATE__;

        return url;
    }
    loadAnimations
}
